import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ModalController, PopoverController } from '@ionic/angular';
import { DirectorioService } from 'src/app/generales/login/services/directorio.service';

import { SelectPhoneCodeComponent } from 'src/app/generales/components/select-phone-code/select-phone-code.component';
import { PaisService } from 'src/app/generales/services/pais.service';
import { AdminServiceService } from '../../service/admin-service.service';
import { UiService } from '../../service/ui.service';

@Component({
  selector: 'Amarillas-create-bank',
  templateUrl: './create-bank.component.html',
  styleUrls: ['./create-bank.component.scss'],
})
export class CreateBankComponent implements OnInit {
  @Input() onEditCurrency: any;
  bankForm: UntypedFormGroup;
  socialInput: any = this.paisService.countrys[0];
  currencies: any[];
  createdBanks: any[] = [];
  editing = false;
  idBankSelected: number;
  storeId: number;

  constructor(
    private fb:UntypedFormBuilder,
    private modalController: ModalController,
    private popoverController: PopoverController,
    private paisService: PaisService,
    private adminSv: AdminServiceService,
    private uiSv: UiService,
    private directorioSv: DirectorioService
  ) { }

  ngOnInit() {
    this.bankForm = this.fb.group({
      nameBank: [''],
      name: [''],
      typeDoc: [''],
      dni: [''],
      number: [''],
      numberAccount: [''],
      accountType: [''],
      email: ['']
    })

    if(!this.onEditCurrency?.store){
      const num = this.onEditCurrency?.number;
      if(num){
        // const codePhone = this.paisService.countrys.find((number) => num.includes(number.prefPhone));
        // if(!codePhone) return;
        // const numFix = num.slice(codePhone.prefPhone.length, num.length);
        // this.onEditCurrency.number = numFix;
        // this.socialInput = codePhone;
        this.bankForm.patchValue(this.onEditCurrency);
        this.editing = true;
      }
    }

    if(this.onEditCurrency?.store){
      this.bankForm.addControl('currencyId', new UntypedFormControl(''))
      this.adminSv.getCurrencies().subscribe((res:any) => {
        this.currencies = res.data;
      })
      this.createdBanks = this.onEditCurrency.createdBanks;
    }
  }

  setBankId(ev){
    const idBank = ev.detail.value;    
    if(idBank === 'create'){
      this.bankForm.reset();
      this.idBankSelected = undefined;
      this.editing = false;
    }else{
      this.idBankSelected = idBank;
      const findBank = this.createdBanks.find(bank => bank.id === idBank);
      this.storeId = findBank.store_id;
      console.log(findBank);
      
      this.bankForm.patchValue(findBank);
      this.editing = true;
    }
  }

  async changeCode() {
    const popover = await this.popoverController.create({
      component: SelectPhoneCodeComponent,
    });
    await popover.present();
    const data = await popover.onWillDismiss();
    if (data.data) {
      this.socialInput = data.data;
    }
  }


  closeModal(closed){
    if(this.idBankSelected !== undefined){
      this.bankForm.value.id = this.idBankSelected;
    }
    this.modalController.dismiss(closed ? null : this.bankForm.value, ( this.editing ) ? 'edit' : 'create');
  }

  async deleteBank(){
    const res = await this.uiSv.presentAlert('Seguro de eliminar este banco?', 'Esta acción es irreversible');
    if(res.role === 'accept'){
      const data = {
        id: this.idBankSelected,
        storeId: this.storeId
      }
      this.directorioSv.deleteBank(data).subscribe(res => {
        this.modalController.dismiss({id: this.idBankSelected, action: 'delete'});
      })
    }
  }
}
